import { render, staticRenderFns } from "./chartPieDataPackages.vue?vue&type=template&id=b2d33e3c&scoped=true"
import script from "./chartPieDataPackages.vue?vue&type=script&lang=js"
export * from "./chartPieDataPackages.vue?vue&type=script&lang=js"
import style0 from "./chartPieDataPackages.vue?vue&type=style&index=0&id=b2d33e3c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d33e3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2d33e3c')) {
      api.createRecord('b2d33e3c', component.options)
    } else {
      api.reload('b2d33e3c', component.options)
    }
    module.hot.accept("./chartPieDataPackages.vue?vue&type=template&id=b2d33e3c&scoped=true", function () {
      api.rerender('b2d33e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/towerControl/dashboard/components/chartPieDataPackages.vue"
export default component.exports